function timer(timeInSecs, cb) {
    let t = timeInSecs;
    cb(t);
    t--;
    const id = setInterval(() => {
        if (t > -1) {
            cb(t);
            t--;
        }
        else {
            clearInterval(id);
        }
    }, 1000);
    return id;
}

export { timer };
//# sourceMappingURL=timer.js.map
